export const GET_CARDS_REQUEST = 'GET_CARDS_REQUEST';
export const GET_CARDS_SUCCESS = 'GET_CARDS_SUCCESS';

export const SEARCH_CARDS_REQUEST = 'SEARCH_CARDS_REQUEST';
export const SEARCH_CARDS_SUCCESS = 'SEARCH_CARDS_SUCCESS';

export const SAVE_CARD_REQUEST = 'SAVE_CARD_REQUEST';
export const SAVE_CARD_SUCCESS = 'SAVE_CARD_SUCCESS';
export const SAVE_CARD_FAIL = 'SAVE_CARD_FAIL';

export const SAVE_CARD_TEMPORARILY = 'SAVE_CARD_TEMPORARILY';

export const ADD_CARD_REQUEST = 'ADD_CARD_REQUEST';
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS';

export const EDIT_CARD_REQUEST = 'EDIT_CARD_REQUEST';
export const EDIT_CARD_SUCCESS = 'EDIT_CARD_SUCCESS';

export const EDIT_CARD_TIME_PERIOD = 'EDIT_CARD_TIME_PERIOD';

export const DELETE_CARD_REQUEST = 'DELETE_CARD_REQUEST';
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS';
export const DELETE_CARD_FAIL = 'DELETE_CARD_FAIL';

export const STATUS_PENDING = 'STATUS_PENDING';
export const STATUS_APPROVED = 'STATUS_APPROVED';
export const STATUS_DECLINED = 'STATUS_DECLINED';
export const STATUS_RETURNED = 'STATUS_RETURNED';

export const CLEAR_PAGE_REQUEST = 'CLEAR_PAGE_REQUEST';
export const CLEAR_PAGE_SUCCESS = 'CLEAR_PAGE_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/Cards.js